<template>
  <div>
    <div v-if="src && src.endsWith('.docx')">
      <vue-office-docx :src="src" style="height: 100vh;" />
    </div>

    <div v-if="src && src.endsWith('.xlsx')">
      <vue-office-excel :src="src" style="height: 100vh;" />
    </div>

    <div v-if="src && src.endsWith('.pdf')">
      <vue-office-pdf :src="src" style="height: 100vh" />
    </div>

    <div v-if="src && src.endsWith('.pptx')">
      <vue-office-pptx :src="src" style="height: 100vh" />
    </div>

  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx';
import '@vue-office/docx/lib/index.css';

import VueOfficeExcel from '@vue-office/excel';
import '@vue-office/excel/lib/index.css';

import VueOfficePdf from '@vue-office/pdf';

import VueOfficePptx from '@vue-office/pptx';

export default {
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
    VueOfficePptx
  },
  data () {
    return {
      src: "",

      docx: 'https://501351981.github.io/vue-office/examples/dist/static/test-files/test.docx',
      excel: 'https://501351981.github.io/vue-office/examples/dist/static/test-files/test.xlsx',
      pdf: 'https://501351981.github.io/vue-office/examples/dist/static/test-files/test.pdf',
      pptx: 'https://501351981.github.io/vue-office/examples/dist/static/test-files/test.pptx',
    };
  },
  created () {
    const { path, name } = this.$route.query;
    console.log(path, name);
    this.src = path;
  },

  methods: {
  }
};
</script>